/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ resourceType: NonNullable<unknown> }} Audit_Resource_Type_LabelInputs */

const en_audit_resource_type_label = /** @type {(inputs: Audit_Resource_Type_LabelInputs) => LocalizedString} */ (i) => {
	if (i?.resourceType === "auth") return /** @type {LocalizedString} */ (`Auth`);
	if (i?.resourceType === "cases") return /** @type {LocalizedString} */ (`Cases`);
	if (i?.resourceType === "clients") return /** @type {LocalizedString} */ (`Clients`);
	if (i?.resourceType === "branches") return /** @type {LocalizedString} */ (`Branches`);
	if (i?.resourceType === "tasks") return /** @type {LocalizedString} */ (`Tasks`);
	if (i?.resourceType === "documents") return /** @type {LocalizedString} */ (`Documents`);
	if (i?.resourceType === "admin") return /** @type {LocalizedString} */ (`Admin`);
	if (i?.resourceType === "profile") return /** @type {LocalizedString} */ (`Profile`);
	return /** @type {LocalizedString} */ (`${i?.resourceType}`)
	
};

const pt_br2_audit_resource_type_label = /** @type {(inputs: Audit_Resource_Type_LabelInputs) => LocalizedString} */ (i) => {
	if (i?.resourceType === "auth") return /** @type {LocalizedString} */ (`Autenticação`);
	if (i?.resourceType === "cases") return /** @type {LocalizedString} */ (`Casos`);
	if (i?.resourceType === "clients") return /** @type {LocalizedString} */ (`Clientes`);
	if (i?.resourceType === "branches") return /** @type {LocalizedString} */ (`Filiais`);
	if (i?.resourceType === "tasks") return /** @type {LocalizedString} */ (`Atividades`);
	if (i?.resourceType === "documents") return /** @type {LocalizedString} */ (`Documentos`);
	if (i?.resourceType === "admin") return /** @type {LocalizedString} */ (`Administração`);
	if (i?.resourceType === "profile") return /** @type {LocalizedString} */ (`Perfil`);
	return /** @type {LocalizedString} */ (`${i?.resourceType}`)
	
};

/**
* | resourceType | output |
* | --- | --- |
* | "auth" | "Auth" |
* | "cases" | "Cases" |
* | "clients" | "Clients" |
* | "branches" | "Branches" |
* | "tasks" | "Tasks" |
* | "documents" | "Documents" |
* | "admin" | "Admin" |
* | "profile" | "Profile" |
* | * | "{resourceType}" |
*
* @param {Audit_Resource_Type_LabelInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const audit_resource_type_label = /** @type {((inputs: Audit_Resource_Type_LabelInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Resource_Type_LabelInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_audit_resource_type_label(inputs)
	return pt_br2_audit_resource_type_label(inputs)
});